/**
 * iter 220 (2026-02): 简易图片全屏预览 lightbox。
 * 用于 Cart 表格产品缩略图点击 → 弹出高清全屏视图看材质纹理。
 * 依赖 shadcn Dialog 处理 focus trap + ESC 关闭。
 */
import { Dialog, DialogContent } from "./ui/dialog";
import { X } from "lucide-react";

export default function ImageLightbox({ src, alt, open, onOpenChange }) {
  if (!src) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 bg-black/95 border-none"
        data-testid="image-lightbox"
      >
        {/* 关闭按钮浮在图片右上角 */}
        <button
          onClick={() => onOpenChange(false)}
          data-testid="image-lightbox-close"
          className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm transition-colors"
          aria-label="Close"
        >
          <X size={18} strokeWidth={2} />
        </button>
        <div className="flex items-center justify-center p-4 min-w-[300px] min-h-[300px]">
          <img
            src={src}
            alt={alt || "Product image"}
            className="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
            data-testid="image-lightbox-img"
          />
        </div>
        {alt && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm text-white text-xs max-w-[80vw] truncate">
            {alt}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
